module.exports = ".social__icon {\r\n  width: 40px;\r\n  border-radius: 50%;\r\n}\r\n"